var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container oiline-shop-setting" },
    [
      _vm.currentItem
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 1 } },
                _vm._l(_vm.themeList, function(item, key) {
                  return _c("div", [
                    _c("div", {
                      staticClass: "theme-color",
                      class: { checked: item.name == _vm.themeSel.name },
                      style: { "background-color": item.color },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.onThemeChecked(item)
                        }
                      }
                    }),
                    _c("div", { staticClass: "theme-color-value" }, [
                      _vm._v(_vm._s(item.color))
                    ])
                  ])
                }),
                0
              ),
              _c("el-col", { attrs: { span: 7 } }, [
                _c("div", { staticClass: "phone-preview" }, [
                  _vm.tabSel === "home"
                    ? _c("div", { staticClass: "phone-page" }, [
                        _c(
                          "div",
                          { staticClass: "phone-top" },
                          [
                            _c("el-image", {
                              staticClass: "phone-top-bg",
                              attrs: {
                                src:
                                  "https://bairun-oss.oss-cn-shenzhen.aliyuncs.com/client-shop/images/" +
                                  _vm.themeSel.name +
                                  "/nav-top.png",
                                fit: "fill"
                              }
                            }),
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-top.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "phone-banner active",
                            class: {
                              checked: _vm.currentItem.menuLocationType == 1
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onItemSelect(1)
                              }
                            }
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/online-shop-banner-demo.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "active",
                            class: {
                              checked: _vm.currentItem.menuLocationType == 2
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onItemSelect(2)
                              }
                            }
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-1.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "active",
                            class: {
                              checked: _vm.currentItem.menuLocationType == 3
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onItemSelect(3)
                              }
                            }
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-2.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "active",
                            class: {
                              checked: _vm.currentItem.menuLocationType == 5
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onItemSelect(5)
                              }
                            }
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-3.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.tabSel === "category"
                    ? _c("div", { staticClass: "phone-page" }, [
                        _c(
                          "div",
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2023-01-16/phone-category.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.tabSel === "cart"
                    ? _c("div", { staticClass: "phone-page" }, [
                        _c(
                          "div",
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2023-01-16/cart.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.tabSel === "user"
                    ? _c("div", { staticClass: "phone-page" }, [
                        _c(
                          "div",
                          { staticClass: "phone-top" },
                          [
                            _c("el-image", {
                              staticClass: "phone-top-bg",
                              attrs: {
                                src:
                                  "https://bairun-oss.oss-cn-shenzhen.aliyuncs.com/client-shop/images/" +
                                  _vm.themeSel.name +
                                  "/nav-top.png",
                                fit: "fill"
                              }
                            }),
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-top2.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-5.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "active",
                            class: {
                              checked: _vm.currentItem.menuLocationType == 7
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onItemSelect(7)
                              }
                            }
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-2.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("el-image", {
                              attrs: {
                                src:
                                  "https://oss.bairunpower.com/uploads/2022-12-08/phone-6.png",
                                fit: "fill"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "phone-bottom" }, [
                    _c("div", { staticClass: "tab-bar" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item",
                          style:
                            "color:" +
                            (_vm.tabSel === "home" ? _vm.themeSel.color : ""),
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onTabSelect("home")
                            }
                          }
                        },
                        [
                          _c("el-image", {
                            attrs: {
                              src:
                                "https://bairun-oss.oss-cn-shenzhen.aliyuncs.com/client-shop/images/" +
                                (_vm.tabSel === "home"
                                  ? _vm.themeSel.name
                                  : "common") +
                                "/tabbar/home.png",
                              fit: "fill"
                            }
                          }),
                          _c("div", [_vm._v("首页")])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "item",
                          style:
                            "color:" +
                            (_vm.tabSel === "category"
                              ? _vm.themeSel.color
                              : ""),
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onTabSelect("category")
                            }
                          }
                        },
                        [
                          _c("el-image", {
                            attrs: {
                              src:
                                "https://bairun-oss.oss-cn-shenzhen.aliyuncs.com/client-shop/images/" +
                                (_vm.tabSel === "category"
                                  ? _vm.themeSel.name
                                  : "common") +
                                "/tabbar/category.png",
                              fit: "fill"
                            }
                          }),
                          _c("div", [_vm._v("分类")])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "item",
                          style:
                            "color:" +
                            (_vm.tabSel === "cart" ? _vm.themeSel.color : ""),
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onTabSelect("cart")
                            }
                          }
                        },
                        [
                          _c("el-image", {
                            attrs: {
                              src:
                                "https://bairun-oss.oss-cn-shenzhen.aliyuncs.com/client-shop/images/" +
                                (_vm.tabSel === "cart"
                                  ? _vm.themeSel.name
                                  : "common") +
                                "/tabbar/cart.png",
                              fit: "fill"
                            }
                          }),
                          _c("div", [_vm._v("购物车")])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "item",
                          style:
                            "color:" +
                            (_vm.tabSel === "user" ? _vm.themeSel.color : ""),
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onTabSelect("user")
                            }
                          }
                        },
                        [
                          _c("el-image", {
                            attrs: {
                              src:
                                "https://bairun-oss.oss-cn-shenzhen.aliyuncs.com/client-shop/images/" +
                                (_vm.tabSel === "user"
                                  ? _vm.themeSel.name
                                  : "common") +
                                "/tabbar/user.png",
                              fit: "fill"
                            }
                          }),
                          _c("div", [_vm._v("我的")])
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "circle-line" })
                  ])
                ])
              ]),
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 10 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: { label: "选择店铺：" }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            filterable: "",
                                            placeholder: "搜索条件"
                                          },
                                          on: { change: _vm.init },
                                          model: {
                                            value: _vm.formData.sellerId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "sellerId",
                                                $$v
                                              )
                                            },
                                            expression: "formData.sellerId"
                                          }
                                        },
                                        _vm._l(_vm.sellerOptions, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.sellerId,
                                            attrs: {
                                              label: item.sellerName,
                                              value: item.sellerId
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.currentItem.menuLocationType !== undefined
                    ? _c(
                        "el-row",
                        { staticClass: "right-content bairun-grey-bg" },
                        [
                          _vm.currentItem.menuLocationType == 1
                            ? _c(
                                "div",
                                { staticClass: "bairun-group" },
                                [
                                  _c("p", [_vm._v("首页banner图")]),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "355px" },
                                            attrs: {
                                              placeholder: "请输入链接地址"
                                            },
                                            on: {
                                              blur: _vm.onAddImgUrl,
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              }
                                            },
                                            model: {
                                              value: _vm.addImgUrl,
                                              callback: function($$v) {
                                                _vm.addImgUrl = $$v
                                              },
                                              expression: "addImgUrl"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("upload-image", {
                                        staticStyle: {
                                          display: "inline-block"
                                        },
                                        attrs: {
                                          "file-size": 200,
                                          "is-press": true,
                                          "max-w-h": 1080,
                                          multiple: true,
                                          "auto-upload": true,
                                          height: "160px",
                                          width: "355px",
                                          tips:
                                            "建议尺寸355px * 160px，自动压缩，不超过200kb"
                                        },
                                        on: {
                                          onUploadSuccess: _vm.imgUploadSuccess
                                        }
                                      }),
                                      _c("el-row", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "edit-list bairun-margin-t"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "left" },
                                              [
                                                _c(
                                                  "draggable",
                                                  {
                                                    staticClass:
                                                      "draggable-content",
                                                    attrs: {
                                                      group: "bannerImgUrl",
                                                      animation: "500",
                                                      "chosen-class":
                                                        "bairun-draggable-chosen"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentItem
                                                          .menuList,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentItem,
                                                          "menuList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentItem.menuList"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "transition-group",
                                                      {
                                                        attrs: {
                                                          type: "transition",
                                                          name:
                                                            "bannerImgUrl-list"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.currentItem
                                                          .menuList,
                                                        function(item, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "bannerImgUrl" +
                                                                index,
                                                              staticClass:
                                                                "upload-img bairun-margin-r bairun-margin-b",
                                                              class: {
                                                                checked:
                                                                  item.checked
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.onSubItemSelect(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                staticClass:
                                                                  "banner-img",
                                                                attrs: {
                                                                  src:
                                                                    item.imgUrl,
                                                                  fit: "fit",
                                                                  "preview-src-list":
                                                                    item.imgUrl
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "el-image-viewer__btn el-image-viewer__close",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.onDeleteItem(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-close"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right bairun-margin-r"
                                              },
                                              [
                                                _vm.currentSubItem
                                                  ? _c(
                                                      "el-form",
                                                      {
                                                        attrs: {
                                                          model:
                                                            _vm.currentSubItem,
                                                          "label-position":
                                                            "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "状态："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .menuStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "menuStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.menuStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 5
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "启用"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 6
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "禁用"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "点击跳转："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .jumpType,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "jumpType",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.jumpType"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.jumpTypeOptions,
                                                                        function(
                                                                          item
                                                                        ) {
                                                                          return _c(
                                                                            "el-radio",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm.currentSubItem
                                                          .jumpType == 1
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "h5链接："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 2
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            attrs: {
                                                                              filterable:
                                                                                "",
                                                                              placeholder:
                                                                                "或选择小程序页面"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.jumpUrlOptions,
                                                                            function(
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key:
                                                                                    item.path,
                                                                                  attrs: {
                                                                                    label:
                                                                                      item.name,
                                                                                    value:
                                                                                      item.path
                                                                                  }
                                                                                }
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序appid："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .appid,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "appid",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.appid"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentItem.menuLocationType == 2
                            ? _c(
                                "div",
                                { staticClass: "bairun-group" },
                                [
                                  _c("p", [_vm._v("首页菜单")]),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "355px" },
                                            attrs: {
                                              placeholder: "请输入链接地址"
                                            },
                                            on: {
                                              blur: _vm.onAddImgUrl,
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              }
                                            },
                                            model: {
                                              value: _vm.addImgUrl,
                                              callback: function($$v) {
                                                _vm.addImgUrl = $$v
                                              },
                                              expression: "addImgUrl"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("upload-image", {
                                        staticStyle: {
                                          display: "inline-block"
                                        },
                                        attrs: {
                                          "file-size": 100,
                                          "is-press": true,
                                          "max-w-h": 1080,
                                          multiple: true,
                                          "auto-upload": true,
                                          height: "160px",
                                          width: "355px",
                                          tips:
                                            "图标比例：1 : 1，自动压缩，不超过100kb"
                                        },
                                        on: {
                                          onUploadSuccess: _vm.imgUploadSuccess
                                        }
                                      }),
                                      _c("el-row", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "edit-list bairun-margin-t"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "left" },
                                              [
                                                _c(
                                                  "draggable",
                                                  {
                                                    staticClass:
                                                      "draggable-content",
                                                    attrs: {
                                                      group: "menuImgUrl",
                                                      animation: "500",
                                                      "chosen-class":
                                                        "bairun-draggable-chosen"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentItem
                                                          .menuList,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentItem,
                                                          "menuList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentItem.menuList"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "transition-group",
                                                      {
                                                        attrs: {
                                                          type: "transition",
                                                          name:
                                                            "menuImgUrl-list"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.currentItem
                                                          .menuList,
                                                        function(item, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "menuImgUrl" +
                                                                index,
                                                              staticClass:
                                                                "upload-img bairun-margin-r bairun-margin-b",
                                                              class: {
                                                                checked:
                                                                  item.checked
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.onSubItemSelect(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                staticClass:
                                                                  "menu-img",
                                                                attrs: {
                                                                  src:
                                                                    item.imgUrl,
                                                                  fit: "fit",
                                                                  "preview-src-list":
                                                                    item.imgUrl
                                                                }
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "menu-text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.menuName
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "el-image-viewer__btn el-image-viewer__close",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.onDeleteItem(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-close"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right bairun-margin-r"
                                              },
                                              [
                                                _vm.currentSubItem
                                                  ? _c(
                                                      "el-form",
                                                      {
                                                        attrs: {
                                                          model:
                                                            _vm.currentSubItem,
                                                          "label-position":
                                                            "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "菜单名称："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-input",
                                                                      {
                                                                        attrs: {
                                                                          placeholder:
                                                                            "自定义输入",
                                                                          clearable:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          input: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.inputChange(
                                                                              $event
                                                                            )
                                                                          }
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .menuName,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "menuName",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.menuName"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "状态："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .menuStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "menuStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.menuStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 5
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "启用"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 6
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "禁用"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "点击跳转："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .jumpType,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "jumpType",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.jumpType"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.jumpTypeOptions,
                                                                        function(
                                                                          item
                                                                        ) {
                                                                          return _c(
                                                                            "el-radio",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm.currentSubItem
                                                          .jumpType == 1
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "h5链接："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 2
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            attrs: {
                                                                              filterable:
                                                                                "",
                                                                              placeholder:
                                                                                "或选择小程序页面"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.jumpUrlOptions,
                                                                            function(
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key:
                                                                                    item.path,
                                                                                  attrs: {
                                                                                    label:
                                                                                      item.name,
                                                                                    value:
                                                                                      item.path
                                                                                  }
                                                                                }
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序appid："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .appid,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "appid",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.appid"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentItem.menuLocationType == 3
                            ? _c(
                                "div",
                                { staticClass: "bairun-group" },
                                [
                                  _c("p", [_vm._v("首页广告位")]),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "355px" },
                                            attrs: {
                                              placeholder: "请输入链接地址"
                                            },
                                            on: {
                                              blur: _vm.onAddImgUrl,
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              }
                                            },
                                            model: {
                                              value: _vm.addImgUrl,
                                              callback: function($$v) {
                                                _vm.addImgUrl = $$v
                                              },
                                              expression: "addImgUrl"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("upload-image", {
                                        staticStyle: {
                                          display: "inline-block"
                                        },
                                        attrs: {
                                          "file-size": 200,
                                          "is-press": true,
                                          "max-w-h": 1080,
                                          multiple: true,
                                          "auto-upload": true,
                                          height: "160px",
                                          width: "355px",
                                          tips:
                                            "建议尺寸355px * 100px，自动压缩，不超过200kb"
                                        },
                                        on: {
                                          onUploadSuccess: _vm.imgUploadSuccess
                                        }
                                      }),
                                      _c("el-row", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "edit-list bairun-margin-t"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "left" },
                                              [
                                                _c(
                                                  "draggable",
                                                  {
                                                    staticClass:
                                                      "draggable-content",
                                                    attrs: {
                                                      group: "adImgUrl",
                                                      animation: "500",
                                                      "chosen-class":
                                                        "bairun-draggable-chosen"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentItem
                                                          .menuList,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentItem,
                                                          "menuList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentItem.menuList"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "transition-group",
                                                      {
                                                        attrs: {
                                                          type: "transition",
                                                          name: "adImgUrl-list"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.currentItem
                                                          .menuList,
                                                        function(item, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "adImgUrl" +
                                                                index,
                                                              staticClass:
                                                                "upload-img bairun-margin-r bairun-margin-b",
                                                              class: {
                                                                checked:
                                                                  item.checked
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.onSubItemSelect(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                staticClass:
                                                                  "ad-img",
                                                                attrs: {
                                                                  src:
                                                                    item.imgUrl,
                                                                  fit: "fit",
                                                                  "preview-src-list":
                                                                    item.imgUrl
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "el-image-viewer__btn el-image-viewer__close",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.onDeleteItem(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-close"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right bairun-margin-r"
                                              },
                                              [
                                                _vm.currentSubItem
                                                  ? _c(
                                                      "el-form",
                                                      {
                                                        attrs: {
                                                          model:
                                                            _vm.currentSubItem,
                                                          "label-position":
                                                            "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "状态："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .menuStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "menuStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.menuStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 5
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "启用"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 6
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "禁用"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "点击跳转："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .jumpType,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "jumpType",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.jumpType"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.jumpTypeOptions,
                                                                        function(
                                                                          item
                                                                        ) {
                                                                          return _c(
                                                                            "el-radio",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm.currentSubItem
                                                          .jumpType == 1
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "h5链接："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 2
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            attrs: {
                                                                              filterable:
                                                                                "",
                                                                              placeholder:
                                                                                "或选择小程序页面"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.jumpUrlOptions,
                                                                            function(
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key:
                                                                                    item.path,
                                                                                  attrs: {
                                                                                    label:
                                                                                      item.name,
                                                                                    value:
                                                                                      item.path
                                                                                  }
                                                                                }
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序appid："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .appid,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "appid",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.appid"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentItem.menuLocationType == 5
                            ? _c(
                                "div",
                                { staticClass: "bairun-group" },
                                [
                                  _c("p", [_vm._v("首页专区会场")]),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "355px" },
                                            attrs: {
                                              placeholder: "请输入链接地址"
                                            },
                                            on: {
                                              blur: _vm.onAddImgUrl,
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              }
                                            },
                                            model: {
                                              value: _vm.addImgUrl,
                                              callback: function($$v) {
                                                _vm.addImgUrl = $$v
                                              },
                                              expression: "addImgUrl"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("upload-image", {
                                        staticStyle: {
                                          display: "inline-block"
                                        },
                                        attrs: {
                                          "file-size": 200,
                                          "is-press": true,
                                          "max-w-h": 1080,
                                          multiple: true,
                                          "auto-upload": true,
                                          height: "160px",
                                          width: "355px",
                                          tips:
                                            "建议尺寸355px * 100px，自动压缩，不超过200kb"
                                        },
                                        on: {
                                          onUploadSuccess: _vm.imgUploadSuccess
                                        }
                                      }),
                                      _c("el-row", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "edit-list bairun-margin-t"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "left" },
                                              [
                                                _c(
                                                  "draggable",
                                                  {
                                                    staticClass:
                                                      "draggable-content",
                                                    attrs: {
                                                      group: "areaImgUrl",
                                                      animation: "500",
                                                      "chosen-class":
                                                        "bairun-draggable-chosen"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentItem
                                                          .menuList,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentItem,
                                                          "menuList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentItem.menuList"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "transition-group",
                                                      {
                                                        attrs: {
                                                          type: "transition",
                                                          name:
                                                            "areaImgUrl-list"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.currentItem
                                                          .menuList,
                                                        function(item, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "areaImgUrl" +
                                                                index,
                                                              staticClass:
                                                                "upload-img bairun-margin-r bairun-margin-b",
                                                              class: {
                                                                checked:
                                                                  item.checked
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.onSubItemSelect(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                staticClass:
                                                                  "area-img",
                                                                attrs: {
                                                                  src:
                                                                    item.imgUrl,
                                                                  fit: "fit",
                                                                  "preview-src-list":
                                                                    item.imgUrl
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "el-image-viewer__btn el-image-viewer__close",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.onDeleteItem(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-close"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right bairun-margin-r"
                                              },
                                              [
                                                _vm.currentSubItem
                                                  ? _c(
                                                      "el-form",
                                                      {
                                                        attrs: {
                                                          model:
                                                            _vm.currentSubItem,
                                                          "label-position":
                                                            "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "状态："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .menuStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "menuStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.menuStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 5
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "启用"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 6
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "禁用"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm.currentSubItem
                                                          .jumpType == 2
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "专区会场："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            attrs: {
                                                                              filterable:
                                                                                "",
                                                                              placeholder:
                                                                                "选择专区会场"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.areaOptions,
                                                                            function(
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key:
                                                                                    item.path,
                                                                                  attrs: {
                                                                                    label:
                                                                                      item.name,
                                                                                    value:
                                                                                      item.path
                                                                                  }
                                                                                }
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentItem.menuLocationType == 7
                            ? _c(
                                "div",
                                { staticClass: "bairun-group" },
                                [
                                  _c("p", [_vm._v("我的页面广告位")]),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "355px" },
                                            attrs: {
                                              placeholder: "请输入链接地址"
                                            },
                                            on: {
                                              blur: _vm.onAddImgUrl,
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              }
                                            },
                                            model: {
                                              value: _vm.addImgUrl,
                                              callback: function($$v) {
                                                _vm.addImgUrl = $$v
                                              },
                                              expression: "addImgUrl"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("upload-image", {
                                        staticStyle: {
                                          display: "inline-block"
                                        },
                                        attrs: {
                                          "file-size": 200,
                                          "is-press": true,
                                          "max-w-h": 1080,
                                          multiple: true,
                                          "auto-upload": true,
                                          height: "160px",
                                          width: "355px",
                                          tips:
                                            "建议尺寸355px * 100px，自动压缩，不超过200kb"
                                        },
                                        on: {
                                          onUploadSuccess: _vm.imgUploadSuccess
                                        }
                                      }),
                                      _c("el-row", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "edit-list bairun-margin-t"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "left" },
                                              [
                                                _c(
                                                  "draggable",
                                                  {
                                                    staticClass:
                                                      "draggable-content",
                                                    attrs: {
                                                      group: "adImgUrl",
                                                      animation: "500",
                                                      "chosen-class":
                                                        "bairun-draggable-chosen"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentItem
                                                          .menuList,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentItem,
                                                          "menuList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentItem.menuList"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "transition-group",
                                                      {
                                                        attrs: {
                                                          type: "transition",
                                                          name:
                                                            "mineAdImgUrl-list"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.currentItem
                                                          .menuList,
                                                        function(item, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "mineAdImgUrl" +
                                                                index,
                                                              staticClass:
                                                                "upload-img bairun-margin-r bairun-margin-b",
                                                              class: {
                                                                checked:
                                                                  item.checked
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.onSubItemSelect(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                staticClass:
                                                                  "ad-img",
                                                                attrs: {
                                                                  src:
                                                                    item.imgUrl,
                                                                  fit: "fit",
                                                                  "preview-src-list":
                                                                    item.imgUrl
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "el-image-viewer__btn el-image-viewer__close",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.onDeleteItem(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-close"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right bairun-margin-r"
                                              },
                                              [
                                                _vm.currentSubItem
                                                  ? _c(
                                                      "el-form",
                                                      {
                                                        attrs: {
                                                          model:
                                                            _vm.currentSubItem,
                                                          "label-position":
                                                            "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "状态："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .menuStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "menuStatus",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.menuStatus"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 5
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "启用"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-radio",
                                                                          {
                                                                            attrs: {
                                                                              label: 6
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "禁用"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-required",
                                                                    attrs: {
                                                                      label:
                                                                        "点击跳转："
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentSubItem
                                                                              .jumpType,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.currentSubItem,
                                                                              "jumpType",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "currentSubItem.jumpType"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.jumpTypeOptions,
                                                                        function(
                                                                          item
                                                                        ) {
                                                                          return _c(
                                                                            "el-radio",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm.currentSubItem
                                                          .jumpType == 1
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "h5链接："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 2
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            attrs: {
                                                                              filterable:
                                                                                "",
                                                                              placeholder:
                                                                                "或选择小程序页面"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.jumpUrlOptions,
                                                                            function(
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key:
                                                                                    item.path,
                                                                                  attrs: {
                                                                                    label:
                                                                                      item.name,
                                                                                    value:
                                                                                      item.path
                                                                                  }
                                                                                }
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序appid："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .appid,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "appid",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.appid"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.currentSubItem
                                                          .jumpType == 3
                                                          ? _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        staticClass:
                                                                          "bairun-required",
                                                                        attrs: {
                                                                          label:
                                                                            "小程序页面："
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            attrs: {
                                                                              placeholder:
                                                                                "自定义输入",
                                                                              clearable:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.inputChange(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .currentSubItem
                                                                                  .jumpUrl,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.currentSubItem,
                                                                                  "jumpUrl",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "currentSubItem.jumpUrl"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            { staticClass: "edit-form-tool bairun-margin-t" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "medium" },
                                  on: { click: _vm.onSave }
                                },
                                [_vm._v("保存")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }